import React from 'react';
import { IDesignerProfile } from '@components/pages/DesignerProfile/graphql/designer-profile-query.graphql';
import About from '../About/About';
import FAQ from '../FAQ/FAQ';
import DesignerVideo from '../Video/Video';

import styles from './Info.module.scss';

interface IInfoProps {
  designer: IDesignerProfile;
}

const Info = ({ designer }: IInfoProps) => {
  return (
    <>
      <About designer={designer} />

      <div className={ styles.VideoWrapper }>
        <DesignerVideo designer={designer} className={ styles.Video } />
      </div>

      <FAQ designer={designer} />
    </>
  );
};

export default Info;
